export default "__VITE_ASSET__a88ca06f__"